import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProductApiService } from '../../../product/services/api/product-api.service';
import { faChevronLeft, faCopy, faPencil, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { faTiktok } from '@fortawesome/free-brands-svg-icons';
import { ModalService } from '../../../../core/services/modal/modal.service';
import { Location } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { UpdateProductSetNameComponent } from '../../../product/components/update-product-set-name/update-product-set-name.component';
import { PlatformService } from '../../../../core/services/platform/platform.service';
import { UtilService } from '../../../../core/services/util/util.service';
import { UserService } from '../../../../core/services/user/user.service';
import { MatSelectChange } from '@angular/material/select';
import { ProductSetApiService } from '../../../product-set/services/api/product-set-api.service';
import { UpdateTiktokSetPriceComponent } from '../../components/update-tiktok-set-price/update-tiktok-set-price.component';
import { WebConfigService } from '../../../../core/services/web-config/web-config.service';

interface ProductSet {
  set_sku: string;
  name: string;
  active: boolean;
  products: ProductInfo[]
  total_price: number;
  total_srp: number;
  current_total_srp: number;
  price_change: boolean;
  mark_price_change: boolean;


}
interface ProductInfo {
  sku: string;
  name: string;
  qty: number;
  cost: number;
  cost_percent: number;
  srp_price: number;
  price: number;
  current_cost: number;
  current_srp_price: number;
  current_cost_percent: number;
}

@Component({
  selector: 'app-tiktok-set-detial',
  templateUrl: './tiktok-set-detial.component.html',
  styleUrl: './tiktok-set-detial.component.css'
})
export class TiktokSetDetialComponent {
faCopy = faCopy
  faPencil = faPencil
  faPlusCircle = faPlusCircle

  faChevronLeft = faChevronLeft;
  faTiktok = faTiktok;

  setSku = ''

  get costPriceIndex() { return this.webConfigService.tiktokCostPriceIndex; }
  get srpPriceIndex() { return this.webConfigService.srpPriceIndex; }
  get percent() { return this.webConfigService.percenTikTokSetList; }

  productSet: Array<ProductSet> = [];
  currentProductSet: any = {}
  loading = false;

  checkList: Array<{ channel: string, name: string, checked: boolean, user_id: string, date: number }> = []
  channels: any[] = [];
  filteredChannels: any[] = [];
  users: any[] = [];
  channelSelected: any;

  productSetHistory: any[] = []

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private productApiService: ProductApiService,
    private productSetApiService: ProductSetApiService,
    private modalService: ModalService,
    private location: Location,
    public dialog: MatDialog,
    private platformService: PlatformService,
    private util: UtilService,
    private userService: UserService,
    private webConfigService: WebConfigService
  ) {
     this.channels = this.platformService?.channelsAll.filter(item => item.platform === 'TIKTOK') || []
    this.users = this.userService.users
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.route.queryParams.subscribe(async (params) => {
      this.setSku = params['set_sku'];
      await this.loadData()
      this.loading = false;
    });
  }

  async loadData() {
    const response: any = await this.productApiService.getSameTiktokSet(this.setSku)
    const productSetHistoryResult: any = await this.productSetApiService.getProductSetHistory(this.setSku)

    if (response.success && productSetHistoryResult.success) {

      const productSet = []
      for (const set of response.data) {
        productSet.push(this.formatDataProductDetail(set))
      }
      this.productSet = productSet
      this.currentProductSet = this.productSet.find(item => item.set_sku === this.setSku)
      this.checkList = this.currentProductSet?.check_list || []
      this.channelSelected = this.currentProductSet?.check_list?.map((e: any) => e.channel) || []


      const sortedHistory = productSetHistoryResult.data.sort((a: any, b: any) => b.price_updated_date - a.price_updated_date)
      const productSetHistory: any[] = []
      for (const set of sortedHistory) {
        productSetHistory.push(this.formatDataProductHistoryDetail(set, this.currentProductSet.product_info))
      }
      this.productSetHistory = productSetHistory


      this.setFilterdChannel()
    } else {
      this.router.navigate(['/tiktik-set/list'], {})
    }
  }

  formatDataProductDetail(productSet: any) {
    const products = []
    let current_total_srp = 0
    let total_srp = 0

    for (const product of productSet.products) {
      const cost_percent = product.cost + ((this.percent / 100) * product.cost)
      const current_cost = productSet.product_info.find((item: any) => item.sku === product.sku)?.prices[this.costPriceIndex];
      const current_srp_price = productSet.product_info.find((item: any) => item.sku === product.sku)?.prices[this.srpPriceIndex]
      const current_cost_percent = current_cost + ((this.percent / 100) * current_cost)

      total_srp += (product.srp_price * product.qty)
      current_total_srp += (current_srp_price * product.qty)

      products.push({
        ...product,
        name: productSet.product_info.find((item: any) => item.sku === product.sku)?.name,
        cost_percent,
        current_cost,
        current_srp_price,
        current_cost_percent
      })
    }

    return {
      ...productSet,
      products,
      total_srp,
      current_total_srp
    }
  }

  formatDataProductHistoryDetail(productSet: any, productInfo: any) {
    const products = []
    let total_srp = 0

    for (const product of productSet.products) {
      const cost_percent = product.cost + ((this.percent / 100) * product.cost)
      total_srp += (product.srp_price * product.qty)

      products.push({
        ...product,
        name: productInfo.find((item: any) => item.sku === product.sku)?.name,
        cost_percent,
      })
    }

    return {
      ...productSet,
      products,
      total_srp,
    }
  }

  copyProduct() {
    const setSku = this.productSet[0]?.set_sku
    this.router.navigate(['/tiktok-set/create'], { queryParams: { action: 'copy', data: setSku } })
  }

  callbackActiveToggle = (event: boolean, id: string) => {
    const setSku = id.split('-')[2]
    this.productApiService.updateTiktokSet(setSku, { active: event }).then((res: any) => {
      if (res.success && res.data) {
        this.modalService.openModal('success', 'บันทึกสำเร็จ', '')
      } else {
        this.modalService.openModal('fail', 'บันทึกไม่สำเร็จ', '').then(res => {
          const element: any = document.querySelector(`#${id}`)
          element.checked = !event
        })
      }
      this.loadData()
    })
  }

  back() {
    this.location.back();
  }

  showPriceChangeDetail(setSku: string) {
    this.router.navigate(['/tiktok-set/detail'], { queryParams: { set_sku: setSku } })
  }

  async openNameDialog(name: string) {
    const dialogRef = this.dialog.open(UpdateProductSetNameComponent, {
      data: {
        value: name,
        modalName: 'อัพเดตชื่อเซ็ตสินค้า',
        displayCheck: true,
        checkName: 'อัพเดตทั้งหมดที่เซ็ตเหมือนกัน',
        type: 'text'
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result.confirm) {
        if (result.data.updateAll) {
          for (const productset of this.productSet) {
            await this.productApiService.updateTiktokSet(productset.set_sku, { name: result.data.value })
          }
          this.loadData()
        } else {
          this.productApiService.updateTiktokSet(this.setSku, { name: result.data.value }).then((res: any) => {
            if (res.success) {
              this.loadData()
            }
          })
        }
      }
    });
  }

  async openNoteDialog(note: string) {
    const dialogRef = this.dialog.open(UpdateProductSetNameComponent, {
      data: {
        value: note,
        modalName: 'อัพเดตหมายเหตุ',
        displayCheck: false,
        type: 'textarea'
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result.confirm) {
        this.productApiService.updateTiktokSet(this.setSku, { note: result.data.value }).then((res: any) => {
          if (res.success) {
            this.loadData()
          }
        })
      }
    });
  }

  async selectChannel(event: MatSelectChange) {

    const previousSelection = [...this.channelSelected];
    this.channelSelected = event.value;

    const changedValue = previousSelection.length > this.channelSelected.length
      ? previousSelection.find(value => !this.channelSelected.includes(value))
      : this.channelSelected.find((value: any) => !previousSelection.includes(value));

    const isAdded = this.channelSelected.includes(changedValue!);


    if (changedValue && isAdded) {
      const res = await this.addCheckList(changedValue)
      if (!res) {
        this.modalService.openModal('fail', 'บันทึกไม่สำเร็จ', '')
        this.channelSelected = previousSelection;
      }

    } else if (changedValue && !isAdded) {
      const res = await this.removeCheckList(changedValue)
      if (!res) {
        this.channelSelected = previousSelection;
      }
    }

  }

  setFilterdChannel() {
    const mappedChannel = this.checkList.map(item => item.channel)
    this.filteredChannels = this.channels.filter(item => !mappedChannel.includes(item.shop_ref))
    this.channelSelected = mappedChannel;
  }

  async checkChannel(channel: string) {
    const updateData = {
      "check_list": [
        {
          "channel": channel,
          "checked": this.checkList.find(item => item.channel === channel)?.checked
        }
      ]
    }
    const updateResponse: any = await this.productApiService.updateTiktokSetCheckList(this.currentProductSet.set_sku, updateData)
    if (updateResponse.success) {
      this.loadData()
    } else {

    }
  }

  async addCheckList(channel: string) {
    const newCheckList = {
      channel: channel,
      checked: false,
      name: this.channels.find(item => item.shop_ref === channel)?.platform_name
    }
    const updateResponse: any = await this.productApiService.addNewCheckListTiktokSet(this.currentProductSet.set_sku, newCheckList)
    if (updateResponse.success && updateResponse.data) {
      this.checkList = updateResponse.data?.check_list || []
      this.setFilterdChannel()
      return true;
    }
    return false;
  }

  async removeCheckList(channel: string) {
    const updateResponse: any = await this.productApiService.removeCheckListTiktokSet(this.currentProductSet.set_sku, channel)
    if (updateResponse.success && updateResponse.data) {
      this.checkList = updateResponse.data?.check_list || []
      this.setFilterdChannel()
      return true;
    } else {
      this.modalService.openModal('fail', 'บันทึกไม่สำเร็จ', '')
      return false;
    }
  }

  getCheckedCheckLict() {
    return this.checkList.filter(item => item.checked).length
  }

  getUserName(userId: string) {
    return this.users.find(item => item.user_id === userId)?.name
  }

  getDateString(date: number) {
    return this.util.dayjs(date).format('DD/MM/YYYY, HH:mm')
  }

  openUpdatePriceModal() {
    const dialogRef = this.dialog.open(UpdateTiktokSetPriceComponent, {
      data: {
        ...this.currentProductSet
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(async (result: any) => {
      this.loadData()
    });
  }
}
